<template>
    <transition name="modal">
        <div class="modal-mask">
            <a @click="onClose" class="modal-close"></a>
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body">
                        <slick
                                ref="slick"
                                :options="slickOptions"
                        >
                            <div
                                    :key="key"
                                    v-for="(image, key) in images"
                            >
                                <img :src="image" alt="">
                            </div>
                        </slick>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Slick from 'vue-slick'

export default {
  name: 'Modal',
  props: [
    'images'
  ],
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  },
  methods: {
    onClose (event) {
      this.$emit('closed', true)
    }
  }
}
</script>

<style scoped>
    @import '_Modal.scss';
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue